import { useState, useEffect, useRef } from 'react';
import Menu from '../../components/Menu/Menu';
import Footer from '../../components/Footer';
import Toast from '../../components/Toast';
import { getMessageTemplates, updateMessageTemplate, createMessageTemplate, deleteMessageTemplate } from '../../services/MessageTemplatesService';
import MessageModal from './MessageModal';
import MessageRow from './MessageRow';

function Messages() {
    const [messageTemplates, setMessageTemplates] = useState([]);
    const [notification, setNotification] = useState({});
    const [editMessage, setEditMessage] = useState({});
    const [isLoading, setIsLoading] = useState(true);
    const btnClose = useRef(null);

    useEffect(() => {
        loadMessageTemplates();
    }, []);

    function loadMessageTemplates() {
        setIsLoading(true);
        getMessageTemplates()
            .then(result => {
                setMessageTemplates(result);
                setIsLoading(false);
            })
            .catch(err => {
                console.error(err.response ? err.response.data : err.message);
                setNotification({ type: 'error', text: err.response ? err.response.data : err.message });
                setIsLoading(false);
            });
    }

    function onEditClick(event) {
        const id = parseInt(event.target.id.replace('edit', ''));
        const message = messageTemplates.find(m => m.id === id);
        setEditMessage({ ...message });
    }

    function onDeleteClick(event) {
        const id = parseInt(event.target.id.replace('delete', ''));
        const message = messageTemplates.find(m => m.id === id);
        
        if (!window.confirm(`Tem certeza que deseja deletar a mensagem "${message.name}"?`)) {
            return;
        }

        deleteMessageTemplate(id)
            .then(() => {
                setNotification({ type: 'success', text: 'Mensagem deletada com sucesso!' });
                loadMessageTemplates();
            })
            .catch(err => {
                console.error(err.response ? err.response.data : err.message);
                setNotification({ type: 'error', text: err.response ? err.response.data : err.message });
            });
    }

    function onMessageSubmit(message) {
        if (message.id) {
            updateMessageTemplate(message.id, message)
                .then(() => {
                    setNotification({ type: 'success', text: 'Mensagem atualizada com sucesso!' });
                    if (btnClose.current) btnClose.current.click();
                    loadMessageTemplates();
                })
                .catch(err => {
                    console.error(err.response ? err.response.data : err.message);
                    setNotification({ type: 'error', text: err.response ? err.response.data : err.message });
                });
        } else {
            createMessageTemplate(message)
                .then(() => {
                    setNotification({ type: 'success', text: 'Mensagem criada com sucesso!' });
                    if (btnClose.current) btnClose.current.click();
                    loadMessageTemplates();
                })
                .catch(err => {
                    console.error(err.response ? err.response.data : err.message);
                    setNotification({ type: 'error', text: err.response ? err.response.data : err.message });
                });
        }
    }

    return (
        <>
            <Menu />
            <main className="content">
                <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
                    <div className="d-block mb-4 mb-md-0">
                        <h2 className="h4">Mensagens</h2>
                    </div>
                    <div className="btn-toolbar mb-2 mb-md-0">
                        <div className="d-inline-flex align-items-center">
                            <button 
                                className="btn btn-primary animate-up-2" 
                                data-bs-toggle="modal" 
                                data-bs-target="#modalMessage"
                                onClick={() => setEditMessage({})}
                            >
                                <svg className="icon icon-xs me-2" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                    <path fillRule="evenodd" d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z" clipRule="evenodd" />
                                </svg>
                                Nova Mensagem
                            </button>
                        </div>
                    </div>
                </div>
                <div className="card card-body border-0 shadow table-wrapper table-responsive">
                    {isLoading ? (
                        <div className="text-center py-4">
                            <div className="spinner-border" role="status">
                                <span className="visually-hidden">Carregando...</span>
                            </div>
                        </div>
                    ) : (
                        <>
                            <table className="table table-hover">
                                <thead>
                                    <tr>
                                        <th className="border-gray-200">Chave</th>
                                        <th className="border-gray-200">Nome</th>
                                        <th className="border-gray-200">Descrição</th>
                                        <th className="border-gray-200">Assunto</th>
                                        <th className="border-gray-200">Ações</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {messageTemplates && messageTemplates.length > 0 ? (
                                        messageTemplates.map(message => (
                                            <MessageRow 
                                                key={message.id} 
                                                data={message} 
                                                onEditClick={onEditClick} 
                                                onDeleteClick={onDeleteClick} 
                                            />
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="5" className="text-center py-4">
                                                Nenhuma mensagem encontrada. Clique em "Nova Mensagem" para criar uma.
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </>
                    )}
                </div>
                <Footer />
            </main>
            <MessageModal data={editMessage} onSubmit={onMessageSubmit} btnClose={btnClose} />
            <Toast text={notification.text} type={notification.type} />
        </>
    );
}

export default Messages;



